var squaredChordD = require('./../distances/squaredChord');

module.exports = function squaredChord(a, b) {
    return 1 - squaredChordD(a, b);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-distance/src/similarities/squaredChord.js
 ** module id = 113
 ** module chunks = 0
 **/